<template>
  <nav v-if="links.length" class="the-footer-navigation">
    <ul class="flex flex-wrap">
      <li v-for="{ caption, target, to } in links" :key="caption" class="caption-bold">
        <HyperLink v-bind="{ target, to }">
          {{ caption }}
        </HyperLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const { data: footer } = useContent().getFooter()

const links = computed(
  () =>
    // TODO Remove fallbacks when contentful schema finally gets it’s shit together
    footer.value?.items?.[0]?.footerNavigationCollection?.items.map((item) => ({
      caption: item?.caption ?? '',
      target: item?.openInNewTab ? '_blank' : '_self',
      to: item?.url ?? '',
    })) ?? [],
)
</script>

<style lang="scss" scoped>
.the-footer-navigation {
  a {
    @include transition-default(background-color, color);

    position: relative;

    @include hover-state {
      color: token('color/text/accent/fade/accent/fade/hovered');
    }

    @include focus-state {
      z-index: 0;
      color: token('color/text/primary/primary/inverted');

      &::before {
        inset: -#{token('size/border/200')};
        z-index: -1;
        border-radius: token('size/radius/s');
        background-color: token('color/border/accent/focused/focused');
      }
    }
  }

  ul {
    row-gap: token('size/space/gap/200');

    li {
      flex: 0 50%;
    }

    @include media-desktop {
      gap: token('size/space/gap/400');
      justify-content: space-between;

      li {
        flex: none;
      }
    }
  }
}
</style>
